import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { compose } from 'redux';
import { TextField, DatePicker } from 'redux-form-material-ui';
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import * as validator from 'helpers/Validator';
import { RenderError } from 'helpers/Formatter';
import RenderDropzoneMultiFileInput from 'components/shared/RenderDropzoneMultiFileInput';
import Header from 'components/shared/Header';

import { getProperties, getUnits, showUnits } from 'actions/landlordPropertiesActions';
import AssetAssignmentForm from './AssetAssignmentForm';

let AddAssetForm = class AddAssetForm extends Component {
  render() {
    const FILE_FIELD_NAME = 'files';

    return (
      <div className="row">
        <Header name="LOCATION" />
        <div className="row" style={{ marginBottom: '20px', padding: '0 15px' }}>
          <AssetAssignmentForm formName={this.props.form} />
        </div>

        <Header name="ASSET DETAILS" />
        {this.renderAssetDetailsForm()}

        <Header name="PHOTO/FILES" />
        <div className="row" style={{ padding: '20px 30px' }}>
          <Field
            name={FILE_FIELD_NAME}
            component={RenderDropzoneMultiFileInput}
            uploadedFilesKey="photos"
            formName={this.props.formName}
            useViewUploadedFileLinks={true}
            showDeleteButton={true}
          />
        </div>
      </div>
    );
  }

  renderAssetDetailsForm = () => (
    <div className="row" style={{ padding: '0 15px' }}>
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <Field
          name="name"
          type="text"
          component={TextField}
          floatingLabelText="Asset Name*"
          style={{
            marginTop: '-15px',
            fontSize: '14px',
            width: '100%',
          }}
          validate={[validator.required]}
        />
      </div>
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <Field
          name="make"
          type="text"
          component={TextField}
          floatingLabelText="Asset Make*"
          style={{
            marginTop: '-15px',
            fontSize: '14px',
            width: '100%',
          }}
          validate={[validator.required]}
        />
      </div>
      <div className="col-sm-6">
        <Field
          name="category"
          type="text"
          component={TextField}
          floatingLabelText="Asset Category*"
          style={{
            marginTop: '-9px',
            fontSize: '14px',
            width: '100%',
          }}
          validate={[validator.required]}
        />
      </div>
      <div className="col-sm-6">
        <Field
          name="location"
          type="text"
          component={TextField}
          floatingLabelText="Asset Location*"
          style={{
            marginTop: '-15px',
            fontSize: '14px',
            width: '100%',
          }}
          multiLine
          validate={[validator.required]}
        />
      </div>
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <Field
          name="model"
          type="text"
          component={TextField}
          floatingLabelText="Asset Model"
          style={{
            marginTop: '-15px',
            fontSize: '14px',
            width: '100%',
          }}
        />
      </div>
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <Field
          name="serial_number"
          type="text"
          component={TextField}
          floatingLabelText="Asset Serial Number"
          style={{
            marginTop: '-15px',
            fontSize: '14px',
            width: '100%',
          }}
        />
      </div>
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <Field
          name="estimated_replacement_date"
          component={DatePicker}
          floatingLabelText="Est. Replacement Date"
          textFieldStyle={{ fontSize: '14px' }}
          fullWidth
          style={{
            marginTop: '-15px',
            fontSize: '14px',
          }}
        />
      </div>
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <Field
          name="date_manufactured"
          component={DatePicker}
          floatingLabelText="Manufactured Date"
          textFieldStyle={{ fontSize: '14px' }}
          fullWidth
          style={{
            marginTop: '-15px',
            fontSize: '14px',
          }}
        />
      </div>
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <Field
          name="warranty_end_date"
          component={DatePicker}
          floatingLabelText="Warranty End Date"
          textFieldStyle={{ fontSize: '14px' }}
          fullWidth
          style={{
            marginTop: '-15px',
            fontSize: '14px',
          }}
        />
      </div>
      <div className="col-sm-12">
        <Field
          name="description"
          type="text"
          component={TextField}
          floatingLabelText="Asset Description"
          multiLine
          style={{
            marginTop: '-15px',
            marginBottom: '15px',
            fontSize: '14px',
            width: '100%',
          }}
        />
      </div>
      <div className="col-sm-12">
        <Field
          name="emergency_notes"
          type="text"
          component={TextField}
          floatingLabelText="Emergency Notes"
          multiLine
          style={{
            marginTop: '-15px',
            marginBottom: '15px',
            fontSize: '14px',
            width: '100%',
          }}
        />
      </div>
      <div className="col-xs-12" style={{ margin: '-10px 0 20px' }}>
        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <div style={{ fontSize: '14px' }}>Is this asset energy efficient?</div>
        </div>
        <div className="col-xs-12" style={{ textAlign: 'center', margin: '0' }}>
          <BooleanRadioButtons name="energy_efficient" style={{ width: '187px', margin: 'auto' }} />
          <Field name="energy_efficient" component={RenderError} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    form: ownProps.formName,
    properties: state.landlordProperties.properties,
    units: state.landlordProperties.units,
    unitActiveLease: state.landlordProperties.unitActiveLease,
  };
};

export default compose(
  connect(mapStateToProps, {
    getUnits,
    getProperties,
    showUnits,
  }),
  reduxForm({
    enableReinitialize: true,
  })
)(AddAssetForm);
